var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 24,
    viewBox: "0 0 63 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.89543 0.895431 0 2 0H51.3846C52.2632 0 53.0976 0.385105 53.6675 1.05366L61.3406 10.0537C62.2967 11.1751 62.2967 12.8249 61.3406 13.9463L53.6675 22.9463C53.0976 23.6149 52.2632 24 51.3846 24H2C0.895427 24 0 23.1046 0 22V2Z",
    fill: "#E9A5F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepbg);
export default __webpack_public_path__ + "static/media/stepbg.b025780c95437d7480b0fdffc3d2186d.svg";
export { ForwardRef as ReactComponent };